export default __webpack_public_path__ + "static/media/cst_500_smock.bd289de8.jpg";